import { Resource } from "../resource/resource"
import { GTMData } from "../../utils/types"

export interface ResourceGTMConstructor {
    new (_resource: Resource)
}

export const ResourceGTM: ResourceGTMConstructor = class implements GTMData {
    constructor(private _resource: Resource) {}

    get dimension2(): string[] {
        return this._resource.getRootSubjectsValue()
    }
    get dimension3(): string {
        return this._resource.getProjectName()
    }
    get dimension4(): string {
        return this._resource.gradesDisplay
    }
    get dimension11(): string {
        return this._resource.brand ? this._resource.brand.name : ""
    }
    get dimension12(): string {
        return this._resource.getProjectType()
    }
    get dimension13(): string {
        return this._resource.getProjectOrganization()
    }
    get dimension14(): string {
        return this._resource.mediaType
    }
    get dimension28(): string {
        return this._resource.getCollectionTitle()
    }
    get dimension29(): string {
        let firstCollection = this._resource.collection.firstCollection
        if (firstCollection && firstCollection.subcollections) {
            return this._resource.collection.firstCollection.subcollections.join(", ")
        }
        return ""
    }
    get dimension35(): string {
        return this._resource.id
    }
    get gtmObject(): Resource {
        return this._resource
    }
}
